<template>
    <section v-if="parseFloat(data.selectedFanData.moment_of_inertia) && data.params.start_time" class="resistance-torque">
        <h2 v-html="translate('resistance-torque-title')"/>

        <div class="resistance-torque-container">
            <div class="resistance-torque-graph">
                <div class="graphWrapper">
                    <div class="resistance-torque-graph-graph graphWrapper">
                        <span class="speed-of-the-fan-axis-x-label">{{ this.translate("rotor_speed") }} [1/min]</span>
                        <span class="speed-of-the-fan-axis-y-label">{{ this.translate("torque") }} [Nm]</span>
                    </div>
                    <aside class="fanGraphSummary-footer" style="position: static; margin-bottom: 30px; margin-top: -30px;">
                        <aside class="elements-container">
                            <aside class="element">
                                <span class="line rated-speed-line"></span>
                                <span class="text">{{ translate("average_rated_speed_of_the_fan") }}</span>
                            </aside>
                            <aside class="element">
                                <span class="line fow-line"></span>
                                <span class="text">{{ translate("open_inlet") }}</span>
                            </aside>
                            <aside class="element">
                                <span class="line fowz-line"></span>
                                <span class="text">{{ translate("closed_inlet") }}</span>
                            </aside>
                        </aside>
                    </aside>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { resistanceTorque } from '../../resistanceTorque'

    export default {
        name: "resistanceTorque",
        props: ['data'],
        methods: {
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            getVariable(code) {
                let arg = {
                    type: 'getVariable',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);
                if (arg.out === '' || null) {
                    return {variableTranslation: code, variableDefaultKey: 0, variableValues: []};
                }
                return arg.out;
            },
        },
        mounted() {
            if(parseFloat(this.data.selectedFanData.moment_of_inertia))
                new resistanceTorque(document.querySelector('.resistance-torque-graph-graph'), this.$store, this.data, true);
        }
    }
</script>